import {
  ApiClientError,
  Paginated,
  GetConnectorsQuery,
  Connector,
} from '@raydiant/api-client-js';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';

export default function useConnectors(opts: GetConnectorsQuery = {}) {
  const query = useProtectedQuery<Paginated<Connector>, ApiClientError>(
    keys.connectors(),
    () => raydiant.getConnectors(opts),
  );

  return query;
}
